import { SkapaElement } from "@ingka/skapa-webc-element";
const styles = ':host{align-items:center;background-color:rgb(var(--colour-neutral-3,223,223,223));border:.0625rem solid #0000;border-radius:2.125rem;box-sizing:border-box;color:rgb(var(--colour-text-and-icon-1,17,17,17));display:inline-flex;justify-content:center;min-height:2rem;min-width:2rem;padding-inline-end:.5625rem;padding-inline-start:.5625rem}:host([size=small]){min-height:1.25rem;min-width:1.25rem;padding-inline-end:.3125rem;padding-inline-start:.3125rem}:host([colour=black]){background-color:rgb(var(--colour-neutral-7,17,17,17));color:rgb(var(--colour-text-and-icon-5,255,255,255))}:host([colour=white]){background-color:rgb(var(--colour-neutral-1,255,255,255));border-color:rgb(var(--colour-neutral-4,204,204,204));color:rgb(var(--colour-text-and-icon-1,17,17,17))}:host([colour=blue]){background-color:rgb(var(--colour-semantic-informative,0,88,163));color:rgb(var(--colour-text-and-icon-5,255,255,255))}:host([colour=green]){background-color:rgb(var(--colour-semantic-positive,10,138,0));color:rgb(var(--colour-text-and-icon-5,255,255,255))}:host([colour=red]){background-color:rgb(var(--colour-semantic-negative,224,7,81));color:rgb(var(--colour-text-and-icon-5,255,255,255))}:host([colour=orange]){background-color:rgb(var(--colour-semantic-caution,242,106,47));color:rgb(var(--colour-static-black,17,17,17))}:host([colour=yellow]){background-color:rgb(var(--colour-static-ikea-brand-yellow,255,219,0));color:rgb(var(--colour-static-black,17,17,17))}slot[name=icon]{display:block;flex-shrink:0}slot[name=icon]::slotted(*){margin-inline-end:.125rem}:host([icon-only]:not([size=small])){padding:.1875rem}:host([icon-only]:not([size=small])) slot[name=icon]::slotted(*){margin-inline-end:0}:host([size=small]) slot[name=icon]{display:none}:host([size=medium][icon-only]) .label{clip:rect(1px,1px,1px,1px);height:1px;margin:-1px;overflow:hidden;position:absolute;white-space:nowrap;width:1px}.label{display:block;font-size:.75rem;font-weight:700;line-height:1.5;padding:.375rem .125rem;text-align:center}:host([size=small]) .label{padding:0}:host([has-icon]:not([size=small])) .label{text-align:left}';
function generateTemplate({ html }) {
  const template = document.createElement("template");
  template.innerHTML = html`
    <style>
      ${styles}
    </style>
    <slot name="icon"></slot>
    <slot class="label"></slot>
  `;
  return { main: template };
}
class Badge extends SkapaElement {
  constructor() {
    super();
    this.toggleHasIcon = () => {
      this.toggleAttribute("has-icon", this.iconSlot.assignedNodes().length > 0);
    };
    this.gatherProperties(["size", "colour"], this);
    const shadow = this.attachShadow({ mode: "open" });
    const templates = this.getTemplates(generateTemplate);
    shadow.append(templates.main.content.cloneNode(true));
    this.iconSlot = shadow.querySelector("[name=icon]");
  }
  connectedCallback() {
    super.connectedCallback();
    this.iconSlot.addEventListener("slotchange", this.toggleHasIcon);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.iconSlot.removeEventListener("slotchange", this.toggleHasIcon);
  }
  get size() {
    return this.getAttribute("size") || "medium";
  }
  /**
   * Sets size, medium is default.
   */
  set size(size) {
    if (!size) {
      this.removeAttribute("size");
      return;
    }
    this.setAttribute("size", size);
  }
  get colour() {
    return this.getAttribute("colour") || "grey";
  }
  /**
   * Sets background colour and matching label colour. Grey background with
   * black label is default.
   */
  set colour(colour) {
    if (!colour) {
      this.removeAttribute("colour");
      return;
    }
    this.setAttribute("colour", colour);
  }
  get iconOnly() {
    return this.hasAttribute("icon-only");
  }
  set iconOnly(toggle) {
    this.toggleAttribute("icon-only", !!toggle);
  }
}
Badge.skapaTagName = "badge";
Badge.skapaDependencies = [];
export {
  Badge
};
